/* eslint-disable  */
import {
  Box,
  Button,
  Flex,
  SimpleGrid,
  Icon,
  Stack,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  Text,
  Image,
  useColorModeValue,
  Select,
  FormLabel,
  Divider,
  IconButton,
  Grid,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Th,
  Table,
  Thead,
  Tbody,
  Tr,
  Td,
  TableContainer,
  Radio,
  RadioGroup,
  Checkbox,
  Center,
} from "@chakra-ui/react";
import InfiniteScroll from "react-infinite-scroll-component";
import OrderStatus from "components/orderStatus";
import { OptionBase } from "chakra-react-select";
import {
  maskCpfCnpj,
  maskCep,
  ufSelect,
  maskCelular,
  IsEmpty,
  IsNotEmpty,
  maskOnlyNumbers,
  isEmail,
  IsCPF,
  convertData,
  maskDatainfor,
  maskDataInfo,
  isDateStringValid,
  maskSemPontos,
  formatCurrencyFloor,
  maskCaracterEspecial,
  formatarNomeCompleto,
  menor12Anos,
  isAbleToGiveGratuidade,
} from "config/functions";
import { pt } from "date-fns/locale";
import { MdCardMembership, MdHome, MdSearch, MdStore } from "react-icons/md";
//--------------ZENDESK------------------------
import Camera from "components/camera/Camera";
import { ClientePessoaFisica } from "views/admin/atendimento/profile/components/Cliente";

//--------------ZENDESK----------------------^^

// Custom components
import "assets/css/DatePickerInput.css";
import "assets/css/SelectAsync.css";
import Card from "components/card/Card";
import InputField from "components/fields/InputField";
import PopOverAlert from "components/popAlert/popAlert";

import React, { useState, useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import { AuthContext } from "contexts/requiredAuth";

// Assets
import {
  MdFlag,
  MdCheck,
  MdClear,
  MdYoutubeSearchedFor,
  MdOutlineDoubleArrow,
  MdOutlineEngineering,
  MdOutlineClear,
} from "react-icons/md";

import axios from "axios";
import { IoSearch, IoCloseCircle } from "react-icons/io5";
import { CircProgressMini } from "components/charts/CircularProgress";
import TextField from "components/fields/TextField";
import { DateRangePicker } from "react-date-range";

import {
  pesquisaCliente,
  cadastraCliente,
  docsObrigatorios,
  salvaGratuidade,
  salvaRegras,
  editaGratuidade,
  salvarDocsGratuidade,
  listarDocsGratuidade,
  buscarRegrasPorGratuidade,
  enviaEmailAtendimento,
  cadastrarProtocolo,
  buscaCep,
  atualizarProtocolo,
  alteraClienteAtendimento2,
  alteraClienteAtendimento,
  buscarLojasNaAPI,
  buscar2Via,
  buscarHistoricoPedidoCartao,
  finalizarPedidoCartao,
  getOperadoras,
  alterarProtocolo,
  pesquisarDataSenior,
  consultarGratuidadeSenior,
  aprovarGratuidade,
  atualizarRegras,
  alteraClienteAtendimentoFoto,
  checkUserDoc,
} from "config/apis/requests";
import { isEmpty } from "@chakra-ui/utils";
export default function Senior() {
  const { logout, user } = useContext(AuthContext);
  const idTipoGratuidade = 2; // Sênior
  const { push } = useHistory();
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const bgBar = useColorModeValue("secondaryGray.100", "whiteAlpha.100");
  const textColorTertiary = useColorModeValue("secondaryGray.600", "white");
  const textColorSecondary = "secondaryGray.600";
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const iconColor = useColorModeValue("brand.500", "white");
  const [nrSeqEnderecoCasa, setNrSeqEnderecoCasa] = useState([]);
  let dataLoginEndereco: any;
  const [alterarBiometria, setAlterarBiometria] = useState(false);
  const [activeBullets, setActiveBullets] = useState({
    form: true,
    media: false,
    cartao: false,
    validation: false,
  });
  const [modalData, setModalData] = useState(false);
  const [operadora, setOperadora] = useState([]);
  const [idOperadora, setIdOperadora] = useState<number | null>(null); //tirar depois o dois quando tiver usuario com idOperadora
  type Endereco = {
    nrSeqEndereco: number;
    logradouro: string;
    complemento: string;
    bairro: string;
    cidade: string;
    uf: string;
    cep: string;
    numero: string;
    dataInativacao: string | null;
  };

  const handleLogout = () => {
    logout();
    push("/auth/sign-in");
  };

  function obterEnderecoMaisRecente(enderecos: Endereco[]): Endereco {
    if (enderecos?.length === 0) return;
    return enderecos?.reduce((prev, curr) =>
      prev?.nrSeqEndereco > curr?.nrSeqEndereco ? prev : curr,
    );
  }
  function obterEnderecosMaisRecentes(lojas: any) {
    return lojas.map((loja: any) => {
      const enderecoMaisRecente = obterEnderecoMaisRecente(loja.enderecos);
      return {
        ...loja,
        enderecos: [enderecoMaisRecente],
      };
    });
  }

  useEffect(() => {
    const fetchLojas = async () => {
      const res = await buscarLojasNaAPI();
      if (typeof res !== "undefined" && Array.isArray(res)) {
        localStorage.setItem("lojas", JSON.stringify(res));
        setListaDeLojas(obterEnderecosMaisRecentes(res));
        setLojaSelecionada(res[0].codigo);
      } else if (res === 403) {
        setTimeout(() => {
          showPopOver("error", "Ops..", "Sessão expirada, logue novamente!");
        }, 3000);
        handleLogout();
      } else {
        showPopOver(
          "error",
          "Lojas",
          "Erro ao buscar lojas, contate o administrador!",
        );
      }
    };

    fetchLojas();

  }, []);

  useEffect(() => {
    const fetchOperadoras = async () => {
      if (IsEmpty(operadora)) {
        const operadorasResponse = await getOperadoras();
        if (
          !IsEmpty(operadorasResponse) &&
          operadorasResponse !== 500 &&
          operadorasResponse !== 400 &&
          operadorasResponse !== 404
        ) {
          localStorage.setItem(
            "operadoras",
            JSON.stringify(operadorasResponse),
          );
          setOperadora(operadorasResponse);
        }
      }
    };
    if (localStorage.getItem("operadoras") === null) {
      fetchOperadoras();
    } else {
      setOperadora(JSON.parse(localStorage.getItem("operadoras")));
    }
  }, []);

  const formTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const mediaTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const cartaoTab = React.useRef() as React.MutableRefObject<HTMLInputElement>;
  const validationTab =
    React.useRef() as React.MutableRefObject<HTMLInputElement>;
  let cliente = new ClientePessoaFisica();
  const [hasMore, setHasMore] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loadingCarregar, setLoadingCarregar] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [listaDeLojas, setListaDeLojas] = useState([]);
  const [lojaSelecionada, setLojaSelecionada] = useState(null);
  const [ondeReceber, setOndeReceber] = useState("loja");
  const [cartaoVisa, setCartaoVisa] = useState(false);
  const [solicitarPedido, setSolicitarPedido] = useState(false);

  const [showForm, setShowForm] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isCancelOpen, setIsCancelOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [titlePopOver, setTitlePopOver] = useState("Ops...");
  const [subtitlePopOver, setSubtitlePopOver] = useState("");
  const [statusPopOver, setStatusPopOver] = useState("warning");
  const [idGratuidade, setIdGratuidade] = useState(0);
  const [errosList, setErrosList] = useState([]);
  const [temGratuidade, setTemGratuidade] = useState(false);
  const [dataCadastroUser, setDataCadastroUser] = useState("");
  const [viewElements, setViewElements] = useState(false);
  const [usuariosPesquisa, setUsuariosPesquisa] = useState([]);
  const [dataUserTicket, setDataUserTicket] = useState([]);
  const [stateAlterarBiometria, setStateAlterarBiometria] = useState(false);
  const [codigoLojaSelecionada, setCodigoLojaSelecionada] = useState(0);
  const [cdCliente, setCdCliente] = useState(0);
  const [nomeCompleto, setNomeCompleto] = useState("");
  const [nomeSocial, setNomeSocial] = useState("");
  const [dataNascimento, setDataNascimento] = useState("");
  const [msgAlert, setMsgAlert] = useState("");
  const [email, setEmail] = useState("");
  const [sexo, setSexo] = useState("M");
  const [cpfSearch, setCpfSearch] = useState("");
  const [celular, setCelular] = useState("");
  const [image, setImage] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [cep, setCep] = useState("");
  const [numero, setNumero] = useState("");
  const [pontoReferencia, setPontoReferencia] = useState("");
  const [bairro, setBairro] = useState("");
  const [cidade, setCidade] = useState("");
  const [estado, setEstado] = useState("");
  const [checkForm, setCheckForm] = useState(false);
  const [isOpenErro, setIsOpenErro] = useState(false);
  const [recoverLoggedUser, setRecoverLoggedUser] = useState([
    JSON.parse(localStorage.getItem("user")),
  ]);

  const [isOpenAlerta, setIsOpenAlerta] = useState(false);

  const [docsObrigatoriosList, setDocsObrigatoriosList] = useState([]);
  const [files, setFiles] = useState([]);
  const [filesReceived, setFilesReceived] = useState([]);
  const [typeNow, setTypeNow] = useState(0);

  const [existePedido, setExistePedido] = useState(false);
  const [pedidoPrimeiraVia, setPedidoPrimeiraVia] = useState(false);
  const [valorPrimeiraVia, setValorPrimeiraVia] = useState("");
  const [tipoPedidoCartao, setTipoPedidoCartao] = useState("");
  const [valorSegundaVia, setValorSegundaVia] = useState("");
  const [pedidoSegundaVia, setPedidoSegundaVia] = useState(false);
  const [listaOperadoras, setListaOperadoras] = useState([]);
  const [dataValidade, setDataValidade] = useState(new Date());
  const [dataAtual, setDataAtual] = useState(new Date());
  const [addMonth, setAddMonth] = useState(0);
  const [grupos, setGrupos] = useState([]);
  const [linhas, setLinhas] = useState([]);
  const [grupoLinhasSel, setGrupoLinhasSel] = useState([]);
  const [linhasSel, setLinhasSel] = useState([]);
  const [qtdUsoDiario, setQtdUsoDiario] = useState("");
  const [qtdUsoSemanal, setQtdUsoSemanal] = useState("");
  const [qtdUsoMensal, setQtdUsoMensal] = useState("");
  const [horaInicio, setHoraInicio] = useState("");
  const [horaFim, setHoraFim] = useState("");
  const [acompanhante, setAcompanhante] = useState(false);
  const [biometria, setBiometria] = useState(false);
  const [tipoErroPedido, setTipoErroPedido] = useState("");
  const [seg, setSeg] = useState(false);
  const [ter, setTer] = useState(false);
  const [qua, setQua] = useState(false);
  const [qui, setQui] = useState(false);
  const [sex, setSex] = useState(false);
  const [sab, setSab] = useState(false);
  const [dom, setDom] = useState(false);
  const [dataRec, setDataRec] = useState("");
  const [nomeUsuario, setNomeUsuario] = useState("");
  const [continuarChamado, setContinuarChamado] = useState(false);
  const [viewElementBusca, setViewElementBusca] = useState(false);
  const [loginNovo, setLoginNovo] = useState(false);
  const [continuarChamadoDisabled, setContinuarChamadoDisabled] =
    useState(false);
  const [novoChamado, setNovoChamado] = useState(false);
  const [protocoloId, setProtocoloId] = useState(0);

  const [historicoStatus, setHistoricoStatus] = useState([]);
  const [statusAtual, setStatusAtual] = useState(0);
  const [obsRestricao, setObsRestricao] = useState("");

  //--------------ZENDESK------------------------

  const [loadingEncaminhar, setLoadingEncaminhar] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [botaoConfirmar, setBotaoConfirmar] = useState(false);
  const [valueRadio, setValueRadio] = useState("");
  const [protocolo, setProtocolo] = useState([]);
  const [idTipoEndereco, setIdTipoEndereco] = useState("");
  const [uf, setUF] = useState("");
  const [ticketGerado, setTicketGerado] = useState("");
  const [nrSeqEndereco, setNrSeqEndereco] = useState(0);
  const [observacaoChamado, setObservacaoChamado] = useState("");
  const [dataUser, setDataUser] = useState([]);
  const [solicitarCartao, setSolicitarCartao] = useState(false);
  const [handleFotoAlterada, setHandleFotoAlterada] = useState("");
  const [cepUserNovo, setCepUserNovo] = useState("");
  const [clienteProtocolo, setClienteProtocolo] = useState("");
  const [restricao, setRestricao] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);
  const perfisPermitidosBiometria = [
    "ADMINISTRADOR",
    "ATENDENTE_LOJA",
    "SUPERVISOR_LOJA",
    "CADASTRO_SENIOR",
  ];
  let erros: any[] = [];
  let dataRegras: any[] = [];
  let montaList: any[] = [];
  interface PerfisUsuario {
    perfis: string[]; // Suponha que 'perfis' seja uma matriz de strings
    // Outras propriedades do objeto usuário, se houver
  }

  const usuarios: PerfisUsuario[] = [
    // Suponha que você tenha um array de objetos do tipo 'PerfisUsuario' aqui
    {
      perfis: recoverLoggedUser[0]?.perfis,
      // Outras propriedades do usuário, se houver
    },
    // Outros objetos 'PerfisUsuario' aqui
  ];

  const perfisDesejadosDataNascimento = ["ADMINISTRADOR", "SUPERVISOR_LOJA"];
  const perfisDesejados = [
    "ADMINISTRADOR",
    "SUPERVISOR_SENIOR",
    "SUPERVISOR_LOJA",
    "ATENDENTE_LOJA",
    "CADASTRO_SENIOR",
  ];

  const [radioValue, setRadioValue] = useState("loja"); // Valor inicial é "loja"

  const handleRadioChange = (value: string) => {
    if (value === "casa" && restricao) {
      setRadioValue("loja");
      setOndeReceber("loja");
      return;
    }
    setRadioValue(value);
    if (value === "casa") {
      setOndeReceber("casa");
      buscaNrSeq(); // Chama a função para "casa"
    } else {
      setOndeReceber("loja");
    }
  };
  const algumUsuarioCompativel = usuarios.some((usuario) => {
    return usuario.perfis.some((perfil) =>
      perfisPermitidosBiometria.includes(perfil),
    );
  });
  //--------------ZENDESK------------------------^^
  const handleCepNovoUser = (cep: any) => {
    setCepUserNovo(cep);
  };

  const handleCpfProtocolo = (status: any) => {
    setClienteProtocolo(status);
  };

  const verificarCartaoVisa = (e: any) => {
    if (cartaoVisa) {
      setCartaoVisa(false);
    } else {
      setCartaoVisa(true);
    }
  };
  const handleFotoAlteradaIndex = (foto: any) => {
    setHandleFotoAlterada(foto);
  };
  const handleSolicitarCartao = async (status: any, cpfNovo: any) => {
    dataLogin = await pesquisaCliente({
      email: null,
      nome: null,
      numeroDocumento: cpfNovo.replace(/[^\d]+/g, ""),
      tipoBusca: "TODOS",
      tipoPessoa: "F",
    });

    setDataUser(dataLogin[0]);
    if (IsNotEmpty(dataLogin[0].enderecos)) {
      handleFocusChange(dataLogin[0].enderecos[0].cep);
    }
    setViewElementBusca(true);
    setSolicitarCartao(status);
    window.scrollTo(0, 0);
  };
  let dataLogin;

  interface GruposOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }
  interface LinhasOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }
  interface OperadoraOption extends OptionBase {
    label: string;
    value: string;
    colorScheme: string;
  }
  const handleOpenAlertErro = () => {
    setIsOpenErro(!isOpenErro);
  };
  //----ZENDESK-----
  const handleFotoIndex = (foto: any) => {
    setHandleFotoAlterada(foto);
  };
  const onChangeModalDataClose = () => {
    //document.getElementById("fotoElementoUsuario").style.display = "block";
    //document.getElementById("fotoElementoUsuario2").style.display = "block";
    setModalData(!modalData);
  };
  const encaminharAtendimento = () => {
    setLoadingEncaminhar(true);
    const bodyDeskAtualizacao = {
      id: protocolo ?? ticketGerado,
      subject:
        "Chamado encaminhado " + protocolo ??
        "Chamado encaminhado " + ticketGerado,
      description: observacaoChamado,
      requesterName: nomeCompleto,
      requesterEmail: email,
    };

    const bodyCriacaoChamado = {
      idChamado: !IsEmpty(protocolo) ? protocolo : ticketGerado,
      nome: nomeCompleto,
      email: email,
    };

    enviaEmailAtendimento(bodyCriacaoChamado).then(function (result) {
      if (!IsEmpty(result.status)) {
        if (result.status >= 400) {
          showPopOver("error", "Ops...", "Erro ao enviar email!");
        }
      }
    });

    atualizarProtocolo(bodyDeskAtualizacao).then(function (result) {
      // cadastrarProtocoloComentario(protocolo ?? result.id, observacaoChamado);
      showPopOver(
        "success",
        "Atendimento",
        "Atendimento encaminhado com sucesso!",
      );
      setLoadingEncaminhar(false);
      setTimeout(() => {
        window.scrollTo(0, 0);
        window.location.href = "/atendimento#/admin/dashboard";
      }, 3000);
    });
  };

  const handleFocusChange = async (cepChange: any) => {
    setLoadingCep(true);
    const { estado, cidade, bairro, logradouro, restricao } =
      await buscaCep(cepChange);
    setLoadingCep(false);

    if (restricao === 1) {
      setRestricao(true);
    } else {
      setRestricao(false);
    }

    if (!cepChange.includes(".")) {
      setUF(estado);
      setBairro(bairro);
      setCidade(cidade);
      setEstado(estado);
      setLogradouro(logradouro);
      setIdTipoEndereco("2");
      setUF(estado);
    } else {
      setCep(cepChange);
      setUF("");
      setBairro("");
      setCidade("");
      setEstado("");
      setLogradouro("");
    }
  };

  const handleFoto = (foto: any) => {
    if (foto !== "") {
      setImage(foto.replace("data:image/jpeg;base64,", ""));
    }
  };

  useEffect(() => {
    if (stateAlterarBiometria === true) setAlterarBiometria(true);
  }, [stateAlterarBiometria]);

  const temStatusGratuidade = async (codigo: any) => {
    //----------------------------------------------
    let temgratuidadeCliente = await consultarGratuidadeSenior(codigo);
    let mostRecentItem;
    if (!isEmpty(temgratuidadeCliente)) {
      mostRecentItem = temgratuidadeCliente.reduce(
        (prev: any, current: any) => {
          return new Date(prev.dataInclusao) > new Date(current.dataInclusao)
            ? prev
            : current;
        },
      );
    }

    if (
      typeof mostRecentItem === "object" &&
      mostRecentItem?.id !== undefined
    ) {
      setIdGratuidade(mostRecentItem.id);
      setHistoricoStatus(mostRecentItem.historicoStatusGratuidadeList);

      if (mostRecentItem.statusGratuidade.id !== 3) {
        setTemGratuidade(false);
        setStatusAtual(1);
      } else {
        setTemGratuidade(true);
        setStatusAtual(mostRecentItem.statusGratuidade.id);
      }

      if (mostRecentItem.statusGratuidade.id === 8) {
        setTemGratuidade(true);
        showPopOver(
          "error",
          "Gratuidade Sênior",
          "Usuário com gratuidade Sênior cancelada!",
        );
      }
      // preenche OBS restricao
      let obsRestricao = mostRecentItem.historicoStatusGratuidadeList.filter(
        (item: any) => item.descricao !== "",
      );
      setObsRestricao(obsRestricao[0]?.descricao);
    }
  };

  const confirmarAtendimento = (row: any) => {
    setDataUser([]);
    setLoginNovo(false);
    setBotaoConfirmar(true);
    setNovoChamado(true);
    setContinuarChamadoDisabled(true);

    if (row?.base64Imagem) {
      setStateAlterarBiometria(true);
    }

    if (!IsEmpty(row)) {
      if (row.codigo) {
        temStatusGratuidade(row.codigo);
        buscaDadosPedidoCartao(row.codigo);
      }
      setViewElementBusca(true);
      setLoginNovo(false);
      setDataUser(row);
      setLoading(false);
      setViewElements(true);
      onOpen();
      onClose();
      setShowForm(true);
      setValueRadio("");
      setIdOperadora(2);
      //----ZENDESK--------------------
      setCheckForm(true);
      setCpfSearch(row.numeroDocumento);
      setDataCadastroUser(row.dataCadastro);
      setCdCliente(row.codigo);
      setNomeCompleto(row.nome);
      setNomeSocial(row.nomeSocial);
      setDataRec(
        IsNotEmpty(row.dataNascimento)
          ? maskDataInfo(row.dataNascimento + "T00:00:00")
          : "",
      );
      setEmail(row.email);
      setSexo(row.sexo);
      setCelular(maskCelular(row?.telefone));

      if (IsNotEmpty(row.enderecos[0]?.cep)) {
        setNrSeqEndereco(row.enderecos[0]?.nrSeqEndereco);
        setCep(maskCep(row.enderecos[0]?.cep));
        handleFocusChange(row.enderecos[0]?.cep);
        setLogradouro(row.enderecos[0]?.logradouro);
        setUF(row.enderecos[0]?.uf);
        setBairro(row.enderecos[0]?.bairro);
        setNumero(row.enderecos[0]?.numero);
        setCidade(row.enderecos[0]?.cidade);
        setEstado(row.enderecos[0]?.uf);
        setPontoReferencia(row.enderecos[0]?.complemento);
      }

      //media

      setImage(
        row.base64Imagem
          ? "data:image/jpeg;base64," + row.base64Imagem.replace('"', "")
          : "",
      );
    } else if (IsEmpty(row)) {
      setLoginNovo(true);
      setLoading(false);
      setViewElements(true);
      setViewElementBusca(true);
      onClose();
      setShowForm(true);
    } else {
      handleOpenAlert(true);
      setMsgAlert("Erro no sistema, favor tentar novamente!");
    }

    // if ((novoChamado && !IsEmpty(dataUser)) || !IsEmpty(row)) {
    //   cadastrarProtocolo(row, "Início atendimento gratuidade pcd").then(
    //     function (result) {
    //       // cadastrarProtocoloComentario(result.id, "início Atendimento");
    //       setTicketGerado(result.id);
    //       setProtocolo(result.id);
    //     }
    //   );
    // } else if (continuarChamado) {
    //   setProtocolo(dataUserTicket);
    // }
  };

  const finalizarAtendimento = () => {
    showPopOver("success", "Atendimento", "Atendimento encerrado com sucesso!");
    setTimeout(() => {
      window.scrollTo(0, 0);
      window.location.href = "/atendimento#/admin/dashboard";
    }, 2000);
  };
  // ZENDESK ---------------------------------^^

  const showPopOver = (status: string, title: string, subtitle: string) => {
    handleOpenAlert(true);
    setStatusPopOver(status);
    setTitlePopOver(title);
    setSubtitlePopOver(subtitle);
  };

  const preencheDiasSemana = (valor: any) => {
    switch (parseInt(valor)) {
      case 1:
        setDom(true);
        break;
      case 2:
        setSeg(true);
        break;
      case 3:
        setTer(true);
        break;
      case 4:
        setQua(true);
        break;
      case 5:
        setQui(true);
        break;
      case 6:
        setSex(true);
        break;
      case 7:
        setSab(true);
        break;
      default:
        break;
    }
  };

  const getNomeOperadora = (valor: any) => {
    if (IsNotEmpty(listaOperadoras)) {
      let nameOper = listaOperadoras.filter(
        (item: { value: any }) => item.value === valor.toString(),
      );

      return nameOper[0].label;
    }
  };

  const getNomeGrupo = (valor: any) => {
    if (IsNotEmpty(grupos)) {
      let nameGrupo = grupos.filter((item) => item.value === parseInt(valor));

      return nameGrupo[0].label;
    }
  };

  const getNomeLinha = (valor: any) => {
    if (IsNotEmpty(linhas)) {
      let nameLinha = linhas.filter((item) => item.value === parseInt(valor));

      return nameLinha[0].label;
    }
  };

  const handleGetGratuidade = async (
    idCliente: any,
    idStatus: any,
    status: string,
    descricao: string,
    acao: string,
    loginAtendimento: any,
  ) => {
    let retornoGratuidade = [];
    if (acao === "post") {
      retornoGratuidade = await aprovarGratuidade({
        cdCliente: idCliente,
        descricao: descricao,
        tipoGratuidade: {
          id: 2,
          descricao: descricao,
        },
        statusGratuidade: {
          id: idStatus,
          descricao: "Aprovado",
        },
        loginAtendente: loginAtendimento,
      });
    } else {
      retornoGratuidade = await editaGratuidade({
        id: idGratuidade,
        descricao: descricao,
        tipoGratuidade: {
          id: idTipoGratuidade,
          descricao: "Sênior",
        },
        statusGratuidade: {
          id: idStatus,
          descricao: descricao,
        },
        loginAtendente: loginAtendimento,
      });
    }

    const errorMensagem =
      (retornoGratuidade?.errorMessage || "Erro desconhecido") + ".";

    if (
      retornoGratuidade !== undefined &&
      retornoGratuidade !== null &&
      !retornoGratuidade?.errorMessage
    ) {
      setIdGratuidade(retornoGratuidade?.idGratuidade);
      setHistoricoStatus(
        retornoGratuidade.entidadeRetorno.historicoStatusGratuidadeList,
      );
      if (
        retornoGratuidade.entidadeRetorno.statusGratuidade.id === 1 ||
        retornoGratuidade.entidadeRetorno.statusGratuidade.id === 4
      ) {
        setStatusAtual(1);
      } else {
        setStatusAtual(retornoGratuidade.entidadeRetorno.statusGratuidade.id);
      }

      // preenche OBS restricao
      let obsRestricao =
        retornoGratuidade.entidadeRetorno.historicoStatusGratuidadeList.filter(
          (item: any) => item.descricao !== "",
        );
      setObsRestricao(obsRestricao[0]?.descricao);
      setIdGratuidade(retornoGratuidade.entidadeRetorno.id);

      setTimeout(() => {
        showPopOver(
          "success",
          "Gratuidade",
          idStatus == 5 ? "Cancelada!" : "Concedida!",
        );
        setTemGratuidade(true);
        if (solicitarPedido) handlePedido();
      }, 1000);
    } else {
      setTimeout(() => {
        showPopOver("error", "Gratuidade", "Não concedida! " + errorMensagem);
        setTemGratuidade(false);
      }, 1000);
    }
  };

  const onClickPesquisar = async () => {
    setLoading(true);
    setUsuariosPesquisa([]);
    setDataUser([]);
    //setdataUser([]);
    if (cpfSearch && !IsCPF(cpfSearch)) {
      showPopOver("error", "Ops...", "Cpf inválido!");
      setLoading(false);
      return;
    }
    if (
      (nomeUsuario.length > 2 && cpfSearch === "") ||
      (nomeUsuario === "" && cpfSearch.length === 14) ||
      (nomeUsuario.length > 2 && cpfSearch.length === 14)
    ) {
      const docsObrigatoriosRet = await docsObrigatorios(2);
      setDocsObrigatoriosList(
        docsObrigatoriosRet.length > 0 ? docsObrigatoriosRet : [],
      );

      dataLogin = await pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento: cpfSearch.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: 1,
        quantidadePorPaginacao: 10,
      });
      if (dataLogin === 403 || dataLogin === 401) {
        logout();
      } else if (dataLogin === 400 || dataLogin === 404 || dataLogin === 500) {
        handleOpenAlert(true);
        setMsgAlert(
          "Erro ao fazer pesquisa! Entre em contato com o administrador do sistema.",
        );
        setLoading(false);
      } else {
        if (!IsEmpty(dataLogin)) {
          if (dataLogin.length < 5) {
            setHasMore(false);
          } else {
            setHasMore(true);
            setPagina(2);
          }
          setViewElements(false);
          setUsuariosPesquisa(dataLogin);
          setLoading(false);
        } else {
          setUsuariosPesquisa([]);
          setViewElements(false);
          if (cpfSearch) {
            if (!IsEmpty(cpfSearch)) {
              if (
                usuarios[0]?.perfis.some((perfil: string) =>
                  perfisDesejados.includes(perfil),
                )
              ) {
                onOpen();
              } else {
                handleOpenAlert(true);
                setMsgAlert(
                  "Perfil não autorizado a cadastrar novos usuários!",
                );
              }
            } else {
              handleOpenAlert(true);
              setMsgAlert("Cpf inválido!");
            }
          } else {
            handleOpenAlertErro();
            setTipoErroPedido("Usuário(s) não encontrado(s)!");
          }
          setLoading(false);
        }
      }
      setLoading(false);
    } else {
      if (nomeUsuario.length < 3 && cpfSearch === "")
        showPopOver(
          "warning",
          "Ops...",
          "Preencha ao menos 3 caracteres no nome!",
        );
      else if (nomeUsuario === "" && cpfSearch.length < 14)
        showPopOver("warning", "Ops...", "Preencha com um cfp válido!");
      else if (nomeUsuario.length < 3 || cpfSearch.length < 14)
        showPopOver("warning", "Ops...", "Preencha os campos corretamente!");

      //handleOpenAlert(true);
      //setMsgAlert("Cpf ou nome devem ser preenchidos!");
      setLoading(false);
    }
  };

  const handleKeyDown = (e: { key: string }) => {
    if (e.key === "Enter") {
      onClickPesquisar();
    }
  };

  const cleanFields = () => {
    setLoading(false);
    setCheckForm(false);
    setIdGratuidade(0);
    setTemGratuidade(false);
    setNomeSocial("");
    setCodigoLojaSelecionada(0);
    setIdOperadora(null);
    //form
    setCdCliente(0);
    setNomeCompleto("");
    setNomeSocial("");
    setDataRec("");
    setEmail("");
    setSexo("M");
    setCelular("");
    setCep("");
    setUF("");
    setLogradouro("");
    setBairro("");
    setNumero("");
    setCidade("");
    setEstado("");
    setPontoReferencia("");
    setImage("");

    // UPLOADS FILES
    setFiles([]);
    setFilesReceived([]);
    setLinhasSel([]);
    setGrupoLinhasSel([]);
    setAcompanhante(false);
    setBiometria(false);
    setDataValidade(new Date());
    setAddMonth(0);
    setQtdUsoDiario("");
    setQtdUsoMensal("");
    setQtdUsoSemanal("");
    setHoraInicio("");
    setHoraFim("");
    setSeg(false);
    setTer(false);
    setQua(false);
    setQui(false);
    setSex(false);
    setSab(false);
    setDom(false);

    setHistoricoStatus([]);
    setObsRestricao("");

    setActiveBullets({
      form: true,
      media: false,
      cartao: false,
      validation: false,
    });
  };
  const handleSelect = (ranges: any) => {
    setSelectedDateRange(ranges.selection);
  };
  const handleOpenAlert = (
    status: boolean | ((prevState: boolean) => boolean),
  ) => {
    setIsOpen2(status);
  };
  const [selectedDateRange, setSelectedDateRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
  });

  const handleChangeMask = (event: { target: { value: any } }) => {
    const { value } = event.target;
    if (value.length < 15) {
      const valueRet = maskCpfCnpj(value);
      setCpfSearch(valueRet);
    }
  };

  const handleCheckDataSenior = async (dataSenior: any) => {
    const seniorData = await pesquisarDataSenior(convertData(dataSenior));
    if (seniorData?.data?.isSenior === false) {
      return false;
    } else {
      return true;
    }
  };

  const validateForm = () => {
    erros = [];
    if (IsEmpty(nomeCompleto)) {
      erros.push("Nome completo deve ser preenchido!");
    }
    //tirado em 8.05.24 a pedido da adriani
    // if (!IsEmpty(email)) {
    //   // erros.push("Email deve ser preenchido!");

    // if (!IsEmpty(email)) {
    //   // erros.push("Email deve ser preenchido!");

    //   if (!isEmail(email)) {
    //     erros.push("Preencha com um email válido!");
    //   }
    // }

    if (["Partiu"].some((env) => window.config.tenant.includes(env))) {
      if (idOperadora === null) {
        erros.push("Escolha a operadora!");
      }
    }

    if (IsEmpty(dataRec)) {
      erros.push("Data de nascimento deve ser válida!");
    } else {
      if (!isDateStringValid(dataRec)) {
        erros.push("Data de Nascimento deve ser válida!");
        setDataRec("");
      }
    }

    if (IsEmpty(celular)) {
      erros.push("Celular deve ser preenchido!");
    }

    if (erros.length === 0) {
      return true;
    } else {
      setErrosList(erros);
      erros.map((e) => {
        showPopOver("error", "Ops...", e);
        return false;
      });
    }
    erros.splice(0, erros.length);
    setLoading(false);
  };

  useEffect(() => {
    if (idGratuidade > 0 && !dataRegras) {
      const fetchIdGratuidade = async () => {
        dataRegras = await buscarRegrasPorGratuidade(idGratuidade);
        if (IsNotEmpty(dataRegras)) {
          let oper: any[] = [];
          let grupos: any[] = [];
          let linhas: any[] = [];

          dataRegras.map((item: any) => {
            if (item.tipoRegraGratuidade.id === 2) {
              setQtdUsoDiario(item.valor);
            } else if (item.tipoRegraGratuidade.id === 3) {
              setQtdUsoSemanal(item.valor);
            } else if (item.tipoRegraGratuidade.id === 4) {
              setQtdUsoMensal(item.valor);
            } else if (item.tipoRegraGratuidade.id === 5) {
              preencheDiasSemana(item.valor);
            } else if (item.tipoRegraGratuidade.id === 6) {
              linhas.push({
                value: item.valor.toString(),
                label: getNomeLinha(item.valor),
                colorScheme: "purple",
              });
            } else if (item.tipoRegraGratuidade.id === 7) {
              grupos.push({
                value: item.valor.toString(),
                label: getNomeGrupo(item.valor),
                colorScheme: "red",
              });
            } else if (item.tipoRegraGratuidade.id === 8) {
              oper.push({
                value: item.valor.toString(),
                label: getNomeOperadora(item.valor),
                colorScheme: "orange",
              });
            } else if (item.tipoRegraGratuidade.id === 10) {
              let splitHoras = item.valor.split("|");
              setHoraInicio(splitHoras[0]);
              setHoraFim(splitHoras[1]);
            } else if (item.tipoRegraGratuidade.id === 11) {
              if (!IsEmpty(dataUser)) {
                let dataFormat = new Date(item.valor.toString());
                dataFormat.setDate(dataFormat.getDate() + 1);
                setDataValidade(dataFormat);
              }
            } else if (item.tipoRegraGratuidade.id === 12) {
              setAcompanhante(item.valor.toString() === "true" ? true : false);
            } else if (item.tipoRegraGratuidade.id === 13) {
              setBiometria(item.valor.toString() === "true" ? true : false);
            }
          });
          setGrupoLinhasSel(grupos);
          setLinhasSel(linhas);
        }
      };
      if (!temGratuidade) {
        fetchIdGratuidade();
      }
    }
  }, [showPopOver, idGratuidade, temGratuidade]);

  const onClickLimparFiltros = async () => {
    setLojaSelecionada(null);
    setCpfSearch("");
    setNomeUsuario("");
    setUsuariosPesquisa([]);
    setDataCadastroUser("");
    setStateAlterarBiometria(false);
    setTipoPedidoCartao("");
  };

  const buscaDadosPedidoCartao = (id: any) => {
    buscarHistoricoPedidoCartao(id, 3).then(function (result: any) {
      if (result !== 400 || result !== 500) {
        setPedidoPrimeiraVia(result?.temPedidoCartaoPrimeiraVia);
        setPedidoSegundaVia(result?.temPedidoCartaoSegundaVia);
      }

      if (result !== 400 || result !== 500) {
        if (result?.temPedidoCartaoPrimeiraVia === true) {
          setPedidoPrimeiraVia(true);
          setExistePedido(true);
        } else {
          setPedidoPrimeiraVia(false);
        }

        if (result?.temPedidoCartaoSegundaVia === true) {
          setPedidoSegundaVia(true);
          setExistePedido(true);
        } else {
          setPedidoPrimeiraVia(false);
        }

        if (
          result?.tipoPedido === "1 VIA SOLICITADA" ||
          result?.tipoPedido === "2 VIA SOLICITADA"
        ) {
          setExistePedido(true);
        } else if (result?.tipoPedido === "PODE SOLICITAR PRIMEIRA_VIA") {
          setExistePedido(false);
        } else if (result?.tipoPedido === "PODE SOLICITAR SEGUNDA_VIA") {
          setExistePedido(false);
          setTipoPedidoCartao(result?.tipoPedido);
        } else if (result.tipoPedido === "EXISTE") {
          setExistePedido(true);
        }
      }
    });
  };

  const progressGratuidade = () => {
    let ok = 0;
    if (checkForm) ok++;
    if (IsNotEmpty(image)) ok++;
    return ok;
  };

  const nextPageMedia = async (salvarFoto: any) => {
    let isSenior = false;
    if (!IsEmpty(dataRec)) {
      if (isDateStringValid(dataRec)) {
        isSenior = await handleCheckDataSenior(dataRec);
      }
    }
    if (validateForm() && isSenior !== false) {
      setLoading(true);
      let retornoCliente = [];
      if (cdCliente === 0) {
        // cliente novo
        cliente.base64Imagem = handleFotoAlterada
          ? handleFotoAlterada.replace("data:image/jpeg;base64,", "")
          : image.replace("data:image/jpeg;base64,", "");

        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = nomeCompleto.trim();
        cliente.nomeSocial = nomeSocial;
        cliente.tipoDocumento = "CPF";
        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
        cliente.celular = maskOnlyNumbers(celular);
        cliente.telefone = maskOnlyNumbers(celular);
        cliente.sexo = "M";
        cliente.nomeMae = "";
        cliente.nomePai = "";
        cliente.senha = "";
        cliente.confirmacaoSenha = "";
        if (idOperadora) {
          cliente.idOperadora = idOperadora;
        } else {
          cliente.idOperadora = null;
        }
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.nrSeqEndereco = nrSeqEndereco || 0;
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
          delete cliente.id;
        }
        cliente.idTiposPerfisCliente = [2];

        //CADASTRO DO PROTOCOLO====================================================
        await checkUserDoc(
          cliente.numeroDocumento,
          cliente.nome,
          cliente.dataNascimento,
        ).then(async function (result) {
          if (result !== 500 && result !== 400 && result !== 404) {
            if (typeof result !== "number" && result.data) {
              var nationalRegistrationStatusApproved =
                result?.data?.nationalRegistrationStatusApproved;
              var nameApproved = result?.data?.nameApproved;
              var birthDateApproved = result?.data?.birthDateApproved;
              if (
                (nationalRegistrationStatusApproved === true &&
                  nameApproved === true &&
                  birthDateApproved === true) ||
                window.config.tenant === "Homolog" ||
                window.config.tenant === "Dev" ||
                window.config.tenant === "Partiu"
              ) {
                retornoCliente = await cadastraCliente(cliente);

                if (!IsEmpty(retornoCliente)) {
                  setCdCliente(retornoCliente.codigo);
                  const bodyDataUserNovo = {
                    numeroDocumento: cpfSearch,
                    nome: nomeCompleto,
                    email: email,
                  };
                  // if (!ticketGerado ?? !protocolo) {
                  //   cadastrarProtocolo(
                  //     cliente,
                  //     "Início atendimento gratuidade senior"
                  //   ).then(function (result) {
                  //     // cadastrarProtocoloComentario(result.id, "início Atendimento");
                  //     setTicketGerado(result.id);
                  //     setProtocolo(result.id);
                  //   });
                  // }
                  //CADASTRO DO PROTOCOLO====================================================

                  showPopOver("success", "Cadastro", "Salvo com sucesso!");
                  setDataUser(retornoCliente);
                  setLoading(false);
                  setCheckForm(true);

                  if (window.config.tenant === "Partiu") { //todo trocar para partiu
                    validationTab.current.click();
                    setActiveBullets({
                      form: true,
                      media: true,
                      cartao: true,
                      validation: true,
                    });
                  } else {
                    mediaTab.current.click();
                    setActiveBullets({
                      form: true,
                      media: true,
                      cartao: false,
                      validation: false,
                    });
                  }

                } else {
                  showPopOver(
                    "error",
                    "Ops...",
                    retornoCliente?.response?.data?.errorMessages
                      ? retornoCliente?.response?.data?.errorMessages
                      : "Erro ao salvar usuário! \n Verique os campos.",
                  );
                  setLoading(false);
                }
              } else {
                if (nationalRegistrationStatusApproved == false) {
                  showPopOver("error", "Ops...", "Cpf inválido! Erro Dock!");
                }

                if (nameApproved == false) {
                  showPopOver(
                    "error",
                    "Ops...",
                    "Nome informado não condiz com o nome registrado no documento!",
                  );
                }

                if (birthDateApproved == false) {
                  showPopOver(
                    "error",
                    "Ops...",
                    "Data nascimento informado não condiz com a data registrado no documento!",
                  );
                }
                setLoading(false);
              }
            }
          } else {
            showPopOver("error", "Ops...", "Erro ao validar cadastro na Dock!");

            setLoading(false);
          }
        });
      } else if (cdCliente > 0) {
        setLoading(true);
        // alteração de cliente
        alterarBiometria
          ? (cliente.base64Imagem = image.replace(
            "data:image/jpeg;base64,",
            "",
          ))
          : (cliente.base64Imagem = handleFotoAlterada
            ? handleFotoAlterada.replace("data:image/jpeg;base64,", "")
            : image.replace("data:image/jpeg;base64,", ""));
        cliente.tipoImagem = "IMAGEM_ROSTO";
        cliente.nome = nomeCompleto.trim();
        cliente.nomeSocial = nomeSocial;
        cliente.dataNascimento = convertData(dataRec);
        cliente.email = email;
        cliente.id = cdCliente;
        cliente.tipoDocumento = "CPF";
        cliente.numeroDocumento = maskOnlyNumbers(cpfSearch);
        cliente.celular = maskSemPontos(celular);
        cliente.telefone = maskSemPontos(celular);
        cliente.sexo = sexo;
        if (IsNotEmpty(cep)) {
          cliente.cidade = cidade;
          cliente.cep = maskOnlyNumbers(cep);
          cliente.nrSeqEndereco = nrSeqEndereco || 0;
          cliente.bairro = bairro;
          cliente.logradouro = logradouro;
          cliente.numero = numero;
          cliente.idTipoEndereco = 2;
          cliente.complemento = pontoReferencia;
          cliente.uf = uf;
        } else {
          delete cliente.cidade;
          delete cliente.cep;
          delete cliente.nrSeqEndereco;
          delete cliente.bairro;
          delete cliente.logradouro;
          delete cliente.numero;
          delete cliente.idTipoEndereco;
          delete cliente.complemento;
          delete cliente.uf;
          delete cliente.idTipoLogradouro;
          delete cliente.latitude;
          delete cliente.longitude;
        }
        if (dataUser) {
          delete cliente.senha;
          delete cliente.confirmacaoSenha;
        }
        cliente.idTiposPerfisCliente = [2];
        delete cliente.nomeMae;
        delete cliente.nomePai;

        if (salvarFoto === 0) {
          alteraClienteAtendimento2(cliente).then(function (result: any) {
            //setResultAlterarCliente(result);
            if (result.status === 200 || result.status < 400) {
              showPopOver("success", "Cadastro", "Cadastro alterado!");
              setCheckForm(true);
              if (alterarBiometria) {
                cartaoTab.current.click();
                setActiveBullets({
                  form: true,
                  media: true,
                  cartao: true,
                  validation: false,
                });
              } else {

                if (window.config.tenant === "Partiu") { //todo trocar para partiu
                  validationTab.current.click();
                  setActiveBullets({
                    form: true,
                    media: true,
                    cartao: true,
                    validation: true,
                  });
                } else {
                  mediaTab.current.click();
                  setActiveBullets({
                    form: true,
                    media: true,
                    cartao: false,
                    validation: false,
                  });
                }



              }
              setLoading(false);
              // setStatusAtual(1);
            } else {
              setCheckForm(false);
              setActiveBullets({
                form: true,
                media: false,
                cartao: false,
                validation: false,
              });
              formTab.current.click();
              const data = result?.response?.data;
              const erro =
                data?.errorMessages === undefined || IsEmpty(data?.errorMessages)
                  ? "Erro ao alterar usuário!"
                  : data?.errorMessages;

              showPopOver("error", "Ops...", erro);
              setLoading(false);
            }
          });
        } else {
          alteraClienteAtendimentoFoto(cliente).then(function (result) {
            //setResultAlterarCliente(result);
            if (result === 200 || result < 400) {
              showPopOver("success", "Cadastro", "Foto salva!");
              setCheckForm(true);

              cartaoTab.current.click();
              setActiveBullets({
                form: true,
                media: true,
                cartao: true,
                validation: false,
              });

              setLoading(false);
              // setStatusAtual(1);
            } else {
              setCheckForm(false);
              setActiveBullets({
                form: true,
                media: false,
                cartao: false,
                validation: false,
              });
              formTab.current.click();
              const data = result?.response?.data;
              const erro =
                data?.errorMessages === undefined ||
                  isEmpty(data?.errorMessages)
                  ? "Erro ao alterar usuário!"
                  : data?.errorMessages;

              showPopOver(
                "error",
                "Ops...",
                erro,
              );
              setLoading(false);
            }
          });
        }
      }
    } else {
      if (!IsEmpty(dataRec)) {
        if (isSenior === false) {
          showPopOver(
            "error",
            "Ops...",
            "Idade informada é menor que 65 anos, ou inválida!",
          );
        }
      } else {
        showPopOver("error", "Ops...", "A data não deve ser vazia!");
      }
    }
  };
  useEffect(() => {
    setListaDeLojas([]);
    if (listaDeLojas.length > 0) {
      setLojaSelecionada(listaDeLojas[0].codigo);
      const selectedLoja = listaDeLojas.length > 0 ? listaDeLojas[0] : null;
      if (selectedLoja) {
        const nrSeqLoja = selectedLoja.enderecos[0].nrSeqEndereco;
        setCodigoLojaSelecionada(nrSeqLoja);
      }
    }
  }, []);

  const handleLojaChange = (e: any) => {
    const selectedValue = e.target.value;

    if (selectedValue !== "") {
      setLojaSelecionada(selectedValue);
      const selectedLoja = listaDeLojas.find(
        (loja) => loja.codigo == selectedValue,
      );
      if (selectedLoja) {
        const nrSeqLoja = selectedLoja.enderecos[0].nrSeqEndereco;
        setCodigoLojaSelecionada(nrSeqLoja);
      }
    }
  };

  const ticketGerado2 = (status: any) => {
    setProtocolo(status);
    setProtocoloId(status);
    setTicketGerado(status);
    setCheckForm(true);
    // setTicketUserNovo(status);
  };
  const nextPageValidations = async () => {
    let retornoRegras = [];
    let montaList: any[] = [];
    setLoading(true);

    montaList.push({ tipo: 1, valor: "-1" });

    retornoRegras = await salvaRegras(idGratuidade, montaList);

    if (IsNotEmpty(retornoRegras)) {
      setTemGratuidade(false); // refresh files e rules
      cartaoTab.current.click();
      setActiveBullets({
        form: true,
        media: true,
        cartao: true,
        validation: false,
      });
    }
  };

  const cancelarGratuidade = async () => {
    setLoading(true);
    var codigoUsuario: any[] = [dataUser];
    var temgratuidadeCliente: any[] = [
      await consultarGratuidadeSenior(codigoUsuario[0]?.codigo),
    ];
    let mostRecentItem;
    if (!isEmpty(temgratuidadeCliente)) {
      mostRecentItem = temgratuidadeCliente.reduce(
        (prev: any, current: any) => {
          return new Date(prev.dataInclusao) > new Date(current.dataInclusao)
            ? prev
            : current;
        },
      );
    }

    if (typeof mostRecentItem === "object" && !isEmpty(mostRecentItem)) {
      const objetoMaisRecente = mostRecentItem.reduce(
        (maisRecente: any, item: any) => {
          if (item instanceof Array) {
            item.forEach((subItem) => {
              if (subItem.dataInclusao > maisRecente.dataInclusao) {
                maisRecente = subItem;
              }
            });
          } else {
            if (item.dataInclusao > maisRecente.dataInclusao) {
              maisRecente = item;
            }
          }
          return maisRecente;
        },
      );
      if (objetoMaisRecente?.statusGratuidade?.id === 3) {
        handleGetGratuidade(
          codigoUsuario[0]?.codigo,
          5,
          "Cancelado",
          "Cancelado UI-ATENDIMENTO",
          "put",
          recoverLoggedUser[0]?.login,
        );
      } else {
        showPopOver("error", "Gratuidade", "Erro ao cancelar!");
      }

      setLoading(false);
    }
  };

  const handlePedido = () => {
    let usuarioPedido: any[] = [dataUser];
    const bodyPedido: { [key: string]: any } = {
      idCliente: usuarioPedido[0]?.codigo,
      idProduto: 3,
      idTipoMidia: cartaoVisa === true ? 4 : 1,
      numeroDocumento: usuarioPedido[0]?.numeroDocumento,
      nrSeqEndereco:
        ondeReceber === "loja" ? codigoLojaSelecionada : nrSeqEnderecoCasa,
      isAluno: false,
    };

    finalizarPedidoCartao(bodyPedido);
  };

  const buscaNrSeq = async () => {
    try {
      const data: any[] = [dataUser];
      let numeroDocumento = "";

      // Verificar se o array tem elementos e acessar o primeiro item
      if (Array.isArray(data) && data.length > 0) {
        const firstItem = data[0]; // Pega o primeiro item do array
        if (typeof firstItem === "object" && firstItem !== null) {
          numeroDocumento = firstItem.numeroDocumento ?? ""; // Acessa numeroDocumento com segurança
        }
      }

      // Pesquisa cliente
      dataLoginEndereco = await pesquisaCliente({
        email: null,
        nome: null,
        numeroDocumento: numeroDocumento,
        tipoBusca: "TODOS",
        tipoPessoa: "F",
      });
      if (dataLoginEndereco.length > 0) {
        setNrSeqEnderecoCasa(dataLoginEndereco[0]?.enderecos[0]?.nrSeqEndereco);
        if (dataLoginEndereco[0]?.enderecos[0]?.cep) {
          const { restricao } = await buscaCep(
            dataLoginEndereco[0].enderecos[0].cep,
          );
          if (restricao === 1) {
            setRestricao(true);
            setRadioValue("loja");
            setOndeReceber("loja");
          } else {
            setRestricao(false);
          }
        }
      } else {
        showPopOver(
          "warning",
          "Ops...",
          "Cliente sem endereço, cadastre e tente novamente!",
        );
      }
    } catch (error) {
      console.error("Erro ao buscar número sequencial:", error);
    }
  };

  const nextFinallyFree = async () => {
    setLoading(true);
    setTemGratuidade(true);
    montaList.push({ tipo: 13, valor: biometria.toString() });
    var codigoUsuario: any[] = [dataUser];

    let isSenior = [];
    if (isEmpty(dataRec)) {
      isSenior = await pesquisarDataSenior(convertData(dataRec));
    } else {
      isSenior = [];
    }

    //if (isSenior?.data?.isSenior === true || isSenior === true) {
    if (checkForm) {
      var dataLogin = await pesquisaCliente({
        email: null,
        nome: null,
        numeroDocumento: cpfSearch.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
      });
      if (
        dataLogin &&
        dataLogin.length > 0 &&
        dataLogin[0].codigo !== undefined
      ) {
        var temgratuidadeSenior = await consultarGratuidadeSenior(
          dataLogin[0].codigo,
        );
        let mostRecentItem;
        if (!isEmpty(temgratuidadeSenior)) {
          mostRecentItem = temgratuidadeSenior.reduce(
            (prev: any, current: any) => {
              return new Date(prev.dataInclusao) >
                new Date(current.dataInclusao)
                ? prev
                : current;
            },
          );
        }

        if (
          !IsEmpty(mostRecentItem) &&
          mostRecentItem?.id !== undefined &&
          mostRecentItem !== false &&
          mostRecentItem.statusGratuidade.descricao !== "Cancelado"
        ) {
          handleGetGratuidade(
            dataLogin[0]?.codigo,
            3,
            "Aprovado",
            "UI-ATENDIMENTO",
            "put",
            recoverLoggedUser[0]?.login,
          );
        } else {
          handleGetGratuidade(
            dataLogin[0]?.codigo,
            3,
            "Aprovado",
            "UI-ATENDIMENTO",
            "post",
            recoverLoggedUser[0]?.login,
          );
        }
      }
    } else {
      showPopOver(
        "error",
        "Erro gratuidade",
        "Verifique os dados e foto do cliente!",
      );
    }
    // } else {
    //   showPopOver(
    //     "error",
    //     "Erro gratuidade",
    //     "Usuário não possui idade necessária!"
    //   );
    // }

    setLoading(false);
  };

  const updateFiles = (incommingFiles: any) => {
    const dataA = incommingFiles.map((item: any, idx: any) => {
      if (item.type === undefined && item.valid) {
        return Object.assign(item, { type: typeNow });
      } else {
        if (IsNotEmpty(item.errors)) {
          //popOver
          showPopOver("error", "Ops...", item.errors[0]);
        }
        return item;
      }
    });

    // set e limpa array
    setFiles(
      dataA.filter((x: { valid: boolean }) => x.valid === true).concat(files),
    );
  };

  const removeFile = (id: number) => {
    setFiles(files.filter((x) => x.id !== id));
  };

  const [imageSrc, setImageSrc] = useState(undefined);
  const handleSee = (imageSource: any) => {
    setImageSrc(imageSource);
  };

  const getArrayFilesType = (type: any) => {
    const data = files.filter((item) => item.type === type);
    return data;
  };

  // const isUserOver65 = async () => (dtNasc: any) => {
  //   const isSenior = await pesquisarDataSenior(dtNasc);
  //   if (isSenior === true || isSenior === false) {
  //     return isSenior;
  //   } else {
  //     return 0;
  //   }
  // };

  // const validateFormData = (valDate: any) => {
  //   let erros = [];
  //   if (!isDateStringValid(valDate)) {
  //     showPopOver("error", "Ops...", "Data de Nascimento deve ser válida!");
  //     setDataRec("");
  //   } else {
  //     let isSenior = pesquisarDataSenior(valDate);
  //     if (!pesquisarDataSenior(valDate)) {
  //       showPopOver("error", "Ops...", "Idade informada é menor que 65 anos!");
  //       setDataRec("");
  //     }
  //   }
  // };

  const [inputClassName, setInputClassName] = useState(false);
  const fetchMoreData = () => {
    setLoadingCarregar(true);
    if (hasMore) {
      pesquisaCliente({
        email: null,
        nome: nomeUsuario,
        numeroDocumento: cpfSearch.replace(/[^\d]+/g, ""),
        tipoBusca: "TODOS",
        tipoPessoa: "F",
        pagina: pagina,
        quantidadePorPaginacao: 10,
      }).then(async (resultado) => {
        setIsLoading(true);
        if (resultado.length > 0) {
          var cont = pagina + 1;
          setPagina(cont);
          setIsLoading(false);
          // setPesquisar(false);
          setUsuariosPesquisa((prevItems) => [...prevItems, ...resultado]);
          setLoadingCarregar(false);
        } else if (resultado.length < 10) {
          //setPesquisar(false);
          setIsLoading(false);
          setHasMore(false);
          setLoadingCarregar(false);
        }
      });
    } else {
      setIsLoading(false);
      setLoadingCarregar(false);
    }
  };

  const handlePaste = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault(); // Impede o evento de colar
    showPopOver("warning", "Ops...", "Não é possível colar no campo!");
  };

  return (
    <>
      <PopOverAlert
        handleOpenAlert={handleOpenAlert}
        isOpen={isOpen2}
        status={statusPopOver}
        title={titlePopOver}
        subtitle={subtitlePopOver}
      />
      {!showForm ? (
        <Flex
          direction="column"
          minH="100vh"
          pt={{ sm: "125px", lg: "75px" }}
          position="relative"
          mt={"12px"}
        >
          <Flex direction="column" w={{ base: "100%", md: "100%", xl: "100%" }}>
            <Flex
              direction={"row"}
              alignContent={"center"}
              justifySelf={"center"}
            //visibility={viewElements ? "hidden" : "visible"}
            >
              <InputField
                isRequired={true}
                ml={"25px"}
                w="200px"
                h="50px"
                id="cpf"
                label="CPF"
                value={cpfSearch}
                onChange={handleChangeMask}
                onKeyDown={handleKeyDown}
              />

              <InputField
                isRequired={true}
                ml={"25px"}
                w="350px"
                h="50px"
                id="nome"
                label="Nome"
                isInvalid={inputClassName}
                errorBorderColor="red.300"
                value={
                  nomeUsuario
                    ? formatarNomeCompleto(
                      nomeUsuario.replace(
                        /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                        "",
                      ),
                    )
                    : ""
                }
                onKeyDown={handleKeyDown}
                onChange={(e: {
                  target: { value: React.SetStateAction<string> };
                }) => {
                  const isInvalid = e.target.value.length < 3;
                  setInputClassName(isInvalid ? true : false);

                  // Atualizar o valor do estado
                  setNomeUsuario(e.target.value);
                }}
              />

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickPesquisar}
                isLoading={loading}
              >
                <Icon w="14px" h="14px" as={IoSearch} color="white" />
              </IconButton>

              <IconButton
                mt={"30px"}
                ml={"25px"}
                aria-label="share"
                w="40px"
                h="40px"
                variant="brand"
                borderRadius="20%"
                onClick={onClickLimparFiltros}
              >
                <Icon w="14px" h="14px" as={IoCloseCircle} color="white" />
              </IconButton>
            </Flex>
            <Box
              // overflowX="hidden"
              //overflowY={usuariosPesquisa.length > 7 ? "scroll" : "hidden"}
              maxW="100vw"
              h={"490px"}
              whiteSpace="nowrap"
              pb="17px"
              visibility={!viewElements ? "visible" : "hidden"}
            >
              <TableContainer
                visibility={usuariosPesquisa.length > 0 ? "visible" : "hidden"}
                width={"100%"}
                alignSelf={"left"}
                borderBottomStartRadius={"12px"}
              >
                <Table variant="striped" colorScheme="gray">
                  <Thead>
                    <Tr>
                      <Th width={"430px"}>Nome</Th>
                      <Th>DOCUMENTO</Th>
                      <Th></Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                </Table>
              </TableContainer>

              <Flex
                direction="column"
                width={{ xl: "100%", md: "100%", lg: "100%" }}
              >
                <InfiniteScroll
                  dataLength={usuariosPesquisa.length}
                  next={fetchMoreData}
                  hasMore={true}
                  loader={
                    <Flex
                      justify="center"
                      px="10px"
                      pt="5px"
                      mb="25px"
                      mt="20px"
                      alignItems={"center"}
                      justifySelf={"center"}
                    >
                      {!hasMore ? (
                        <Text color={"black"} fontSize="lg" fontWeight="300">
                          {usuariosPesquisa.length > 0 &&
                            "Todos os dados carregados"}
                        </Text>
                      ) : (
                        usuariosPesquisa.length > 0 && (
                          <Flex>
                            <Button
                              variant="action"
                              px="24px"
                              fontSize="sm"
                              fontWeight="700"
                              disabled={hasMore ? false : true}
                              onClick={() => fetchMoreData()}
                              isLoading={loadingCarregar}
                            >
                              {hasMore
                                ? "Carregar mais dados..."
                                : "Não há mais dados"}
                            </Button>
                          </Flex>
                        )
                      )}
                    </Flex>
                  }
                >
                  <TableContainer
                    width={"100%"}
                    alignSelf={"left"}
                    borderBottomStartRadius={"12px"}
                    style={{ overflowY: "scroll", maxHeight: "500px" }}
                  >
                    <Table variant="striped" colorScheme="gray">
                      <Tbody>
                        {usuariosPesquisa.map((row) => {
                          return (
                            <Tr>
                              <Td width={"430px"}>{row.nome}</Td>
                              <Td>
                                {" "}
                                {row.tipoDocumento.codigo === 4
                                  ? maskOnlyNumbers(row.numeroDocumento)
                                  : maskCaracterEspecial(
                                    maskCpfCnpj(row.numeroDocumento),
                                  )}
                              </Td>
                              <Td></Td>
                              <Td>
                                {" "}
                                {isEmpty(row?.dataCancelamento) ? (
                                  <Button
                                    variant="action"
                                    px="24px"
                                    fontSize="sm"
                                    fontWeight="700"
                                    onClick={() => confirmarAtendimento(row)}
                                  >
                                    Iniciar atendimento{" "}
                                  </Button>
                                ) : (
                                  <Text
                                    fontSize="sm"
                                    color={"red"}
                                    fontWeight="700"
                                  >
                                    Conta cancelada
                                  </Text>
                                )}
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </TableContainer>
                </InfiniteScroll>
              </Flex>
            </Box>
          </Flex>
        </Flex>
      ) : null}

      {showForm && (
        <>
          {(protocolo ?? ticketGerado) ? (
            <Flex
              direction="column"
              visibility={viewElements ? "visible" : "hidden"}
              id="fotoElementoUsuario"
              mt={{
                xl: "-0px",
              }}
              ml={{
                base: "22px",
                md: "-48px",
                xl: "-103px",
              }}
              style={{
                position: "fixed",
                top: "8%",
                left: "57%",
                width: "26%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                zIndex: 9999,
              }}
            >
              <Text color={textColorPrimary} fontSize={"16px"}>
                Protocolo:
              </Text>
              <Text
                color={textColorPrimary}
                fontSize={"20px"}
                fontWeight={"700"}
              >
                {ticketGerado ?? protocolo}
              </Text>
            </Flex>
          ) : null}
          <Flex
            direction="column"
            visibility={!IsEmpty(dataUser) ? "visible" : "hidden"}
            id="fotoElementoUsuario2"
            mt={{
              //small: "8px",
              base: "-2px",
              md: "8px",
              xl: "-23px",
            }}
            style={{
              position: "fixed",
              top: "9.5%",
              left: "74%",
              width: "26%",
              transform: "translate(-50%, -50%)",
              padding: "20px",
              zIndex: 9999,
            }}
          >
            {/* {!IsEmpty(dataUser) ? (
              <Profile
                dataUser={dataUser}
                handleFotoIndex={handleFotoIndex}
                cpfBusca={cpfSearch}
                protocolo={protocolo}
              />
            ) : null} */}
          </Flex>
          <Flex
            direction="row"
            pt={{ sm: "125px", lg: "75px" }}
            justifyContent="space-between"
            position="relative"
            mt={"22px"}
          >
            <Button
              variant="darkBrand"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              leftIcon={<MdYoutubeSearchedFor size="20px" />}
              onClick={() => {
                setShowForm(false);
                setCpfSearch("");
                cleanFields();
                setViewElementBusca(false);
                onClickLimparFiltros();
                setCartaoVisa(false);
              }}
            >
              Nova Busca
            </Button>

            <Button
              variant="solid"
              colorScheme="red"
              fontSize="sm"
              borderRadius="16px"
              p="25px"
              isDisabled={!temGratuidade || !isAbleToGiveGratuidade() ? true : false}
              leftIcon={<MdOutlineClear size="20px" />}
              onClick={() => setIsCancelOpen(true)}
            >
              Cancelar Gratuidade
            </Button>
            <Modal
              isOpen={isCancelOpen}
              onClose={() => setIsCancelOpen(false)}
              isCentered
              size={"xl"}
            >
              <ModalOverlay />
              <ModalContent alignSelf={"center"}>
                <ModalHeader>Revogar gratuidade</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                  <Text>
                    Deseja revogar o benefício da gratuidade de{" "}
                    <b>{nomeUsuario || nomeCompleto} </b>?
                  </Text>
                  <Text
                    color={textColor}
                    fontSize="md"
                    fontWeight="300"
                    display="flex"
                    alignItems="center"
                    mt={1}
                  >
                    A partir deste momento não poderá mais ser utilizado o
                    benefício da gratuidade no transporte.
                  </Text>
                </ModalBody>

                <ModalFooter>
                  <Button
                    variant="solid"
                    colorScheme="red"
                    mr={3}
                    onClick={() => {
                      cancelarGratuidade();
                      setIsCancelOpen(false);
                    }}
                  >
                    Sim
                  </Button>
                  <Button
                    variant="light"
                    mr={3}
                    onClick={() => setIsCancelOpen(false)}
                  >
                    Não
                  </Button>
                </ModalFooter>
              </ModalContent>
            </Modal>
          </Flex>
          <Flex
            direction="column"
            minH="100vh"
            align="center"
            pt={{ sm: "125px", lg: "20px" }}
            position="relative"
          >
            <Image
              src={
                "https://io.billingpay.com.br/bp/img/atendimento/gratuidades/seniorBanner.png"
              }
              w="100%"
              position="absolute"
              opacity="30%"
              h="45vh"
              objectFit="cover"
              borderRadius="30px"
              me="40px"
              ml="40px"
              mr="30px"
            />

            <Tabs
              variant="unstyled"
              mt={{ base: "60px", md: "0px" }}
              zIndex="0"
              display="flex"
              flexDirection="column"
              width="100%"
              px={{ base: "10px", md: "0" }}
            >
              <TabList
                display="flex"
                alignItems="center"
                alignSelf="center"
                justifySelf="center"
                flexWrap="wrap"
                justifyContent="center"
              >
                <Tab
                  ref={formTab}
                  w={{ base: "80px", sm: "120px", md: "250px", lg: "250px" }}
                  onClick={() => {
                    setRadioValue("loja");
                    setOndeReceber("loja");
                    setActiveBullets({
                      form: true,
                      media: false,
                      cartao: false,
                      validation: false,
                    });
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { base: "80px", sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.media ? "#5340ff" : "#fff",
                      left: { base: "10px", sm: "12px", md: "30px" },
                      top: {
                        base: "6px",
                        sm: activeBullets.form ? "6px" : "4px",
                        md: null,
                      },
                      position: "absolute",
                      bottom: activeBullets.form ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.form
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.form ? "black" : "gray.800"}
                      fontWeight={activeBullets.form ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Cadastro
                    </Text>
                  </Flex>
                </Tab>
                <Tab
                  ref={mediaTab}
                  w={{ sm: "120px", md: "250px", lg: "250px" }}
                  onClick={async () => {
                    setRadioValue("loja");
                    setOndeReceber("loja");
                    let isSenior;
                    if (!IsEmpty(dataRec))
                      try {
                        isSenior = await handleCheckDataSenior(dataRec);
                      } catch (error) {
                        console.log(error);
                      }
                    if (isSenior) {
                      setActiveBullets({
                        form: true,
                        media: true,
                        cartao: false,
                        validation: false,
                      });
                    } else {
                      formTab.current.click();
                      setActiveBullets({
                        form: true,
                        media: false,
                        cartao: false,
                        validation: false,
                      });
                      showPopOver(
                        "warning",
                        "Ops...",
                        "Usuário não possui idade suficiente ou data está errada!",
                      );
                    }
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                    _before={{
                      content: "''",
                      width: { sm: "120px", md: "250px", lg: "250px" },
                      height: "3px",
                      bg: activeBullets.cartao ? "#5340ff" : "#fff",
                      left: { sm: "12px", md: "53px" },
                      top: "6px",
                      position: "absolute",
                      bottom: activeBullets.media ? "40px" : "38px",
                      transition: "all .3s ease",
                    }}
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.media
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.media ? "black" : "gray.800"}
                      fontWeight={activeBullets.media ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Biometria facial
                    </Text>
                  </Flex>
                </Tab>
                {window.config.tenant !== "Partiu" &&
                  <>
                    <Tab
                      ref={cartaoTab}
                      w={{ base: "80px", sm: "120px", md: "250px", lg: "250px" }}
                      onClick={async () => {
                        let isSenior;
                        if (!IsEmpty(dataRec))
                          try {
                            buscaNrSeq();
                            isSenior = await handleCheckDataSenior(dataRec);
                          } catch (error) {
                            console.log(error);
                          }
                        if (isSenior) {
                          setActiveBullets({
                            form: true,
                            media: true,
                            cartao: true,
                            validation: false,
                          });
                        } else {
                          formTab.current.click();
                          setActiveBullets({
                            form: true,
                            media: false,
                            cartao: false,
                            validation: false,
                          });
                          showPopOver(
                            "warning",
                            "Ops...",
                            "Usuário não possui idade suficiente ou data está errada!",
                          );
                        }
                      }}
                    >
                      <Flex
                        direction="column"
                        justify="center"
                        align="center"
                        position="relative"
                        _before={{
                          content: "''",
                          width: { base: "80px", sm: "120px", md: "50px", lg: "250px" },
                          height: "3px",
                          bg: activeBullets.validation ? "#5340ff" : "#fff",
                          left: { base: "10px", sm: "12px", md: "60px" },
                          top: "6px",
                          position: "absolute",
                          bottom: activeBullets.cartao ? "40px" : "38px",
                          transition: "all .3s ease",
                        }}
                      >
                        <Box
                          zIndex="1"
                          border="2px solid"
                          borderColor="#fff"
                          bg={
                            activeBullets.cartao
                              ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                              : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                          }
                          w="16px"
                          h="16px"
                          mb="8px"
                          borderRadius="50%"
                        />
                        <Text
                          color={activeBullets.cartao ? "black" : "gray.800"}
                          fontWeight={activeBullets.cartao ? "bold" : "normal"}
                          display={{ sm: "none", md: "block" }}
                        >
                          Solicitar cartão
                        </Text>
                      </Flex>
                    </Tab>
                  </>
                }
                <Tab
                  ref={validationTab}
                  w={{ base: "80px", sm: "120px", md: "250px", lg: "250px" }}
                  onClick={async () => {
                    let isSenior;
                    if (!IsEmpty(dataRec))
                      try {
                        isSenior = await handleCheckDataSenior(dataRec);
                      } catch (error) {
                        console.log(error);
                      }
                    if (isSenior) {
                      setActiveBullets({
                        form: true,
                        media: true,
                        cartao: true,
                        validation: true,
                      });
                    } else {
                      formTab.current.click();
                      setActiveBullets({
                        form: true,
                        media: false,
                        cartao: false,
                        validation: false,
                      });
                      showPopOver(
                        "warning",
                        "Ops...",
                        "Usuário não possui idade suficiente ou data está errada!",
                      );
                    }
                  }}
                >
                  <Flex
                    direction="column"
                    justify="center"
                    align="center"
                    position="relative"
                  >
                    <Box
                      zIndex="1"
                      border="2px solid"
                      borderColor="#fff"
                      bg={
                        activeBullets.validation
                          ? "linear-gradient(135deg, #fff 0%, #1bd103 100%)"
                          : "linear-gradient(135deg, #eeeeee 0%, #aaaaaa 100%)"
                      }
                      w="16px"
                      h="16px"
                      mb="8px"
                      borderRadius="50%"
                    />
                    <Text
                      color={activeBullets.validation ? "black" : "gray.800"}
                      fontWeight={activeBullets.validation ? "bold" : "normal"}
                      display={{ sm: "none", md: "block" }}
                    >
                      Finalizar
                    </Text>
                  </Flex>
                </Tab>
              </TabList>
              <TabPanels mt="24px" maxW={{ md: "90%", lg: "100%" }} mx="auto">
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {/* {!IsEmpty(dataUser) ? (
                    <Profile
                      dataUser={dataUser[0]}
                      handleFotoIndex={handleFotoIndex}
                      cpfBusca={cpfSearch}
                    />
                  ) : null} */}
                  <Card p="30px">
                    <Text
                      color={textColor}
                      fontSize="2xl"
                      fontWeight="700"
                      mb="20px"
                    >
                      Dados Pessoais
                    </Text>
                    <Flex direction="column" w="100%">
                      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
                        <Stack direction="column" gap="20px">
                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="nome"
                            isDisabled={
                              !isEmpty(dataCadastroUser) ? true : false
                            }
                            value={formatarNomeCompleto(
                              nomeCompleto.replace(
                                /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                                "",
                              ),
                            )}
                            onChange={(e: {
                              target: { value: React.SetStateAction<string> };
                            }) => setNomeCompleto(e.target.value)}
                            placeholder="Nome Completo"
                            label="Nome Completo"
                          />
                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="cpf"
                            label="CPF"
                            disabled
                            value={maskCpfCnpj(cpfSearch)}
                            onChange={handleChangeMask}
                            onKeyDown={handleKeyDown}
                          />
                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="nome"
                            value={
                              nomeSocial
                                ? formatarNomeCompleto(
                                  nomeSocial.replace(
                                    /[^a-zA-ZáàâãäéèêëíìîïóòôõöúùûüçñÁÀÂÃÄÉÈÊËÍÌÎÏÓÒÔÕÖÚÙÛÜÇÑ\s]/g,
                                    "",
                                  ),
                                )
                                : ""
                            }
                            onChange={(e: {
                              target: { value: React.SetStateAction<string> };
                            }) => setNomeSocial(e.target.value)}
                            placeholder="Nome Social"
                            label="Nome Social"
                          />
                        </Stack>
                        <Stack direction="column" gap="20px">
                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="email"
                            value={email}
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil),
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            onChange={(e: {
                              target: { value: React.SetStateAction<string> };
                            }) => setEmail(e.target.value)}
                            placeholder="Email"
                            label="Email"
                          />
                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="data"
                            isDisabled={
                              isEmpty(dataUser) ||
                                usuarios[0]?.perfis.some((perfil: string) =>
                                  perfisDesejadosDataNascimento.includes(perfil),
                                )
                                ? false
                                : true
                            }
                            label="Data nascimento"
                            value={dataRec}
                            maxLength={10}
                            onChange={(e: {
                              target: { value: React.SetStateAction<string> };
                            }) => {
                              setDataRec(maskDatainfor(e.target.value));
                            }}
                          />

                          <InputField
                            onPaste={handlePaste}
                            mb="0px"
                            id="celular"
                            value={celular}
                            disabled={
                              usuarios[0]?.perfis.some((perfil: string) =>
                                perfisDesejadosDataNascimento.includes(perfil),
                              ) || isEmpty(dataUser)
                                ? false
                                : true
                            }
                            maxLength="15"
                            onChange={(e: {
                              target: { value: React.SetStateAction<string> };
                            }) => setCelular(maskCelular(e.target.value))}
                            placeholder="Celular"
                            label="Celular"
                          />
                        </Stack>
                      </SimpleGrid>
                      {["Partiu"].some((env) =>
                        window.config.tenant.includes(env),
                      ) && (
                          <Flex direction="column" mb="30px" mt="20px" ms="10px">
                            <Text
                              fontSize="sm"
                              fontWeight="700"
                              color={textColor}
                              mb={"10px"}
                              ml={"-10px"}
                            >
                              Operadora
                            </Text>
                            <Select
                              ml={"-10px"}
                              mt={"0px"}
                              required={true}
                              id="operadoras"
                              name="operadoras"
                              height="44px"
                              fontSize="sm"
                              fontWeight="500"
                              borderRadius="16px"
                              defaultValue="0"
                              //@ts-expect-error
                              value={dataUser?.idOperadora ?? null}
                              isDisabled={idOperadora && !IsEmpty(dataUser)}
                              onChange={(e: any) => {
                                setIdOperadora(Number(e.target.value));
                              }}
                            >
                              <option value="0">Selecione a operadora</option>
                              {operadora
                                .filter((item: any) => item?.cliente?.nome)
                                .map((option: any) => (
                                  <option key={option.id} value={option.id}>
                                    {option.cliente.nome}
                                  </option>
                                ))}
                            </Select>
                          </Flex>
                        )}

                      <Divider mb="20px" mt="25px" />
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Endereço
                      </Text>
                      {restricao && (
                        <Text color="red" fontWeight="bold" mb="10px">
                          Cep com restrição de entrega.
                        </Text>
                      )}
                      <SimpleGrid columns={{ base: 1, md: 3 }} gap="20px">
                        <InputField
                          onPaste={handlePaste}
                          isRequired={true}
                          maxLength="10"
                          mb="15px"
                          me="0px"
                          id="cep"
                          label="Cep"
                          value={cep}
                          onChange={(e: { target: { value: any } }) => {
                            if (e.target.value.length === 8) {
                              handleFocusChange(e.target.value);
                            }
                            if (e.target.value.length === 0) {
                              setRestricao(false);
                            }
                            setCep(maskCep(e.target.value));
                          }}
                        />
                      </SimpleGrid>

                      {loadingCep ? (
                        "Carregando..."
                      ) : (
                        <div>
                          {IsNotEmpty(cep) && (
                            <SimpleGrid mt="30px" gap="20px">
                              <InputField
                                disabled
                                onPaste={handlePaste}
                                mb="0px"
                                id="logradouro"
                                value={logradouro}
                                onChange={(e: {
                                  target: {
                                    value: React.SetStateAction<string>;
                                  };
                                }) => setLogradouro(e.target.value)}
                                placeholder="Logradouro"
                                label="Logradouro"
                              />
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ base: 1, md: 2 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  isRequired={true}
                                  mb="20px"
                                  id="numero"
                                  label="Número"
                                  value={numero}
                                  inputMode="numeric"
                                  pattern="[0-9]*"
                                  onChange={(
                                    e: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    const onlyNumbers = e.target.value.replace(
                                      /\D/g,
                                      "",
                                    );
                                    setNumero(onlyNumbers);
                                  }}
                                />
                                <InputField
                                  onPaste={handlePaste}
                                  disabled
                                  mb="0px"
                                  id="cidade"
                                  value={cidade}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setCidade(e.target.value)}
                                  placeholder="Cidade"
                                  label="Cidade"
                                />
                              </Stack>
                              <Stack direction="column" gap="20px">
                                <InputField
                                  onPaste={handlePaste}
                                  disabled
                                  mb="0px"
                                  id="bairro"
                                  value={bairro}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setBairro(e.target.value)}
                                  placeholder="Bairro"
                                  label="Bairro"
                                />
                                <Flex direction="column">
                                  <FormLabel
                                    ms="10px"
                                    htmlFor="estado"
                                    fontSize="sm"
                                    color={textColorPrimary}
                                    fontWeight="bold"
                                    _hover={{ cursor: "pointer" }}
                                  >
                                    Estado
                                  </FormLabel>
                                  <Select
                                    id="estado"
                                    disabled
                                    fontSize="sm"
                                    value={estado}
                                    variant="main"
                                    h="44px"
                                    maxH="44px"
                                    me="20px"
                                    onChange={(e: {
                                      target: {
                                        value: React.SetStateAction<string>;
                                      };
                                    }) => setEstado(e.target.value)}
                                  >
                                    <option value="">Selecione</option>
                                    {ufSelect.map((option) => (
                                      <option value={option.value}>
                                        {option.label}
                                      </option>
                                    ))}
                                  </Select>
                                </Flex>
                              </Stack>
                            </SimpleGrid>
                          )}
                          {IsNotEmpty(cep) && (
                            <SimpleGrid
                              columns={{ md: 1 }}
                              mt="30px"
                              gap="20px"
                            >
                              <Stack direction="column" gap="20px">
                                <InputField
                                  onPaste={handlePaste}
                                  mb="0px"
                                  id="referencia"
                                  value={pontoReferencia}
                                  onChange={(e: {
                                    target: {
                                      value: React.SetStateAction<string>;
                                    };
                                  }) => setPontoReferencia(e.target.value)}
                                  placeholder="Complemento"
                                  label="Complemento"
                                />
                              </Stack>
                            </SimpleGrid>
                          )}
                        </div>
                      )}
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="brand"
                          fontSize="sm"
                          borderRadius="16px"
                          p="25px"
                          ms="auto"
                          rightIcon={<MdOutlineDoubleArrow size="20px" />}
                          isLoading={loading}
                          loadingText="Salvando..."
                          onClick={() => nextPageMedia(0)}
                        >
                          {IsEmpty(dataLogin)
                            ? "Salvar cadastro "
                            : "Alterar cadastro"}
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  {algumUsuarioCompativel ? (
                    <>
                      <Card p="30px" h={"530px"}>
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Foto biométrica
                        </Text>
                        <SimpleGrid
                          columns={{ base: 12, md: 1 }}
                          gap="0px"
                          mb="130px"
                        >
                          <Stack direction="column" gap="20px">
                            <Camera
                              tipoGratuidade={2}
                              dataUser={dataUser}
                              handleFoto={handleFoto}
                              cpfBusca={cpfSearch}
                              nomeUser={nomeCompleto}
                              dtNascimento={dataRec}
                              cep={cep}
                              tipoDocumento={cpfSearch ? "CPF" : "MATRICULA"}
                            ></Camera>
                          </Stack>
                        </SimpleGrid>
                        <Divider mb="20px" mt="110px" />

                        <Flex justify="end" mt="20px">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            disabled={!image ? true : false}
                            w={{ base: "128px", md: "148px" }}
                            h="46px"
                            isLoading={loading}
                            loadingText="Salvando..."
                            rightIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                              //style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => {
                              setStateAlterarBiometria(true);
                              //nextPageValidations();
                              nextPageMedia(1);
                            }}
                          >
                            Salvar foto
                          </Button>
                        </Flex>
                      </Card>
                    </>
                  ) : (
                    <Card p="30px" h={"530px"}>
                      <Text
                        color={textColor}
                        fontSize="2xl"
                        fontWeight="700"
                        mb="20px"
                      >
                        Foto biométrica
                      </Text>

                      <Flex
                        direction="column"
                        w="100%"
                        justifyContent={"center"}
                        align={"center"}
                      >
                        <Text
                          color={"red.300"}
                          fontSize="2xl"
                          mt={"70px"}
                          fontWeight="700"
                          mb="20px"
                        >
                          Perfil não autorizado a tirar foto biométrica!
                        </Text>
                      </Flex>
                      <Flex justify="end" mt="184px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          w={{ base: "128px", md: "148px" }}
                          h="46px"
                          rightIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                            //style={{ rotate: "180deg" }}
                            />
                          }
                          onClick={() => {
                            cartaoTab.current.click();

                            setActiveBullets({
                              form: true,
                              media: true,
                              cartao: true,
                              validation: false,
                            });
                          }}
                        >
                          Próximo
                        </Button>
                      </Flex>
                    </Card>
                  )}
                </TabPanel>
                {window.config.tenant !== "Partiu" &&
                  <>
                    <TabPanel
                      w={{ sm: "330px", md: "700px", lg: "850px" }}
                      p="0px"
                      mx="auto"
                    >
                      <Card p="30px">
                        {(pedidoSegundaVia === false &&
                          pedidoPrimeiraVia === false &&
                          tipoPedidoCartao != "PODE SOLICITAR SEGUNDA_VIA" &&
                          existePedido === false) ||
                          tipoPedidoCartao == "" ? (
                          <Grid
                            flexDirection="column"
                            pt={{ base: "30px", md: "80px", xl: "0px" }}
                          >
                            <Flex direction="column" w="100%">
                              <Text
                                color={textColor}
                                fontSize="2xl"
                                fontWeight="700"
                                mb="20px"
                              >
                                Pedir cartão
                              </Text>
                            </Flex>

                            <Flex alignSelf={"center"} mb={"20px"}>
                              <Checkbox
                                isChecked={cartaoVisa}
                                onChange={(e) => {
                                  verificarCartaoVisa(e.target.checked);
                                }}
                              >
                                <Flex justify="flex-start" alignSelf={"center"}>
                                  <Text
                                    color={textColor}
                                    fontSize="md"
                                    fontWeight="700"
                                  >
                                    Solicitar cartão bandeirado VISA
                                  </Text>

                                  <Icon
                                    ml={"10px"}
                                    as={MdCardMembership}
                                    color={iconColor}
                                    w="24px"
                                    h="24px"
                                  />
                                </Flex>
                              </Checkbox>
                            </Flex>
                            <Flex alignItems="left" mb="20px" direction={"column"} align={"start"}>
                              {restricao && (
                                <Text
                                  color="red.500"
                                  fontSize="md"
                                  fontWeight="700"
                                  mb="10px"
                                >
                                  O endereço do cliente possui restrição de
                                  envio!
                                </Text>
                              )}
                              <Text
                                color={textColorSecondary}
                                fontSize="md"
                                fontWeight="700"
                              >
                                Onde o cliente deseja receber o cartão ?
                              </Text>
                            </Flex>
                            <Flex justify="flex-start">
                              <RadioGroup
                                value={radioValue}
                                onChange={handleRadioChange}
                              >
                                <Flex justify="space-around">
                                  <div style={{ marginRight: 20 }}>
                                    <Radio value="loja" defaultChecked={true}>
                                      Retirada na loja{" "}
                                    </Radio>

                                    <Icon
                                      ml={"10px"}
                                      as={MdStore}
                                      color={iconColor}
                                      w="24px"
                                      h="24px"
                                    />
                                  </div>
                                  <div>
                                    <Radio value="casa" isDisabled={restricao}>
                                      Enviar para residência do cliente
                                    </Radio>

                                    <Icon
                                      as={MdHome}
                                      color={iconColor}
                                      w="24px"
                                      h="24px"
                                    />
                                  </div>
                                </Flex>
                              </RadioGroup>
                            </Flex>
                            {ondeReceber === "loja" ? (
                              <>
                                <div>
                                  <Text
                                    fontSize="sm"
                                    fontWeight="300"
                                    color={textColor}
                                    mt={"20px"}
                                  >
                                    Lista de lojas:
                                  </Text>
                                </div>

                                <Select
                                  isRequired={true}
                                  id="lojas"
                                  name="lojasApi"
                                  h="44px"
                                  fontSize="sm"
                                  fontWeight="500"
                                  borderRadius="16px"
                                  value={lojaSelecionada} // Certifique-se que 'lojaSelecionada' seja "" inicialmente
                                  onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    if (e.target.value !== "0") {
                                      setLojaSelecionada(selectedValue);
                                      const nrSeqLoja = listaDeLojas.filter(
                                        (loja) => {
                                          if (
                                            loja.codigo === parseInt(selectedValue)
                                          ) {
                                            return loja.enderecos[0]?.nrSeqEndereco;
                                          }
                                        },
                                      );
                                      setCodigoLojaSelecionada(
                                        nrSeqLoja[0].enderecos[0]?.nrSeqEndereco,
                                      );
                                    }
                                  }}
                                >
                                  <option value="0">Selecione a loja</option>
                                  {listaDeLojas
                                    .filter((item) => item.codigo !== 733)
                                    .map((option) => (
                                      <option
                                        key={option.codigo}
                                        value={option.codigo}
                                      >
                                        {option.nome}
                                      </option>
                                    ))}
                                </Select>
                                <div style={{ marginTop: 20 }}>
                                  <Text
                                    fontSize="sm"
                                    fontWeight="600"
                                    color={textColor}
                                    mt={"20px"}
                                  >
                                    Endereço da loja:
                                  </Text>

                                  {listaDeLojas &&
                                    listaDeLojas !== undefined &&
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada,
                                    )[0]?.enderecos[0]?.logradouro +
                                    " , " +
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada,
                                    )[0]?.enderecos[0]?.numero +
                                    " - " +
                                    listaDeLojas.filter(
                                      (loja) => loja.codigo == lojaSelecionada,
                                    )[0]?.enderecos[0]?.complemento}
                                </div>
                              </>
                            ) : (
                              cep &&
                              nrSeqEnderecoCasa && (
                                <Flex
                                  justify="flex-start"
                                  mt={"12px"}
                                //  visibility={viewPassoUm ? "visible" : "hidden"}
                                >
                                  <Box
                                    borderWidth="1px"
                                    borderRadius="lg"
                                    overflow="hidden"
                                    w={"full"}
                                  >
                                    <Stack ml={"12px"} mb={"20px"}>
                                      <Text
                                        fontSize="small"
                                        fontWeight="300"
                                        color={textColor}
                                        mt={"20px"}
                                      >
                                        <b>Endereço: </b> {logradouro}{" "}
                                        {" " + numero}
                                        {pontoReferencia && " - " + pontoReferencia}
                                      </Text>
                                      <Text
                                        fontSize="small"
                                        fontWeight="300"
                                        color={textColor}
                                        mt={"20px"}
                                      >
                                        <b>Bairro:</b> {bairro}
                                      </Text>
                                      <Text
                                        fontSize="small"
                                        fontWeight="300"
                                        color={textColor}
                                        mt={"20px"}
                                      >
                                        <b>Cidade:</b> {cidade}
                                      </Text>
                                      <Text
                                        fontSize="small"
                                        fontWeight="300"
                                        color={textColor}
                                        mt={"20px"}
                                      >
                                        <b>Cep:</b> {cep}
                                      </Text>
                                    </Stack>
                                  </Box>
                                </Flex>
                              )
                            )}
                            <div>
                              <Text
                                fontSize="md"
                                fontWeight="500"
                                color={textColor}
                                mt={"20px"}
                              >
                                {ondeReceber === "loja"
                                  ? "A retirada do cartão na loja não possui taxa de entrega e o prazo de entrega é de até 20 dias úteis."
                                  : !nrSeqEnderecoCasa &&
                                  "Cadastre o endereço do cliente antes de solicitar o cartão."}
                              </Text>
                            </div>
                            <Flex justify="end" mt="24px">
                              <Button
                                variant="light"
                                fontSize="sm"
                                borderRadius="16px"
                                w={{ base: "128px", md: "148px" }}
                                //h="46px"
                                isDisabled={
                                  (ondeReceber === "loja" &&
                                    codigoLojaSelecionada !== 0) ||
                                    (ondeReceber !== "loja" && nrSeqEnderecoCasa)
                                    ? false
                                    : true
                                }
                                rightIcon={
                                  <MdOutlineDoubleArrow
                                    size="20px"
                                  //style={{ rotate: "180deg" }}
                                  />
                                }
                                onClick={() => {
                                  setSolicitarPedido(true);
                                  validationTab.current.click();
                                }}
                              >
                                Salvar pedido
                              </Button>
                            </Flex>
                          </Grid>
                        ) : (
                          <Grid
                            flexDirection="column"
                            pt={{ base: "30px", md: "80px", xl: "0px" }}
                          >
                            <Flex direction="column" w="100%" align={"center"}>
                              {tipoPedidoCartao === "PODE SOLICITAR SEGUNDA_VIA" ? (
                                <Text
                                  color={textColor}
                                  fontSize="2X1"
                                  fontWeight="700"
                                >
                                  Gratuidade não permite solicitar 2º via, solicite
                                  pelo menu Cliente!
                                </Text>
                              ) : (
                                <Text
                                  color={textColor}
                                  fontSize="2X1"
                                  fontWeight="700"
                                >
                                  Usuário já possui pedido de cartão!
                                </Text>
                              )}
                            </Flex>
                          </Grid>
                        )}
                      </Card>
                    </TabPanel>
                  </>
                }
                <TabPanel
                  w={{ sm: "330px", md: "700px", lg: "850px" }}
                  p="0px"
                  mx="auto"
                >
                  <Card p="30px">
                    <Grid
                      flexDirection="column"
                      pt={{ base: "30px", md: "80px", xl: "0px" }}
                    >
                      <Flex direction="column" w="100%">
                        <Text
                          color={textColor}
                          fontSize="2xl"
                          fontWeight="700"
                          mb="20px"
                        >
                          Validações
                        </Text>
                        <Flex alignItems="center" mb="20px">
                          <Text
                            color={textColorSecondary}
                            fontSize="md"
                            fontWeight="700"
                          >
                            {progressGratuidade()}/2 FINALIZADO&nbsp;&nbsp;
                            <Icon
                              ms="auto"
                              as={MdFlag}
                              color={
                                progressGratuidade() === 2 ? "green.500" : "red"
                              }
                              h="18px"
                              w="18px"
                            />
                          </Text>
                        </Flex>
                        <SimpleGrid
                          columns={5}
                          gap="5px"
                          alignItems="center"
                          mb="20px"
                        >
                          <Flex
                            bg={checkForm ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />
                          <Flex
                            bg={IsNotEmpty(image) ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          />

                          {/* <Flex
                            bg={IsNotEmpty(operadora) ? "green.500" : bgBar}
                            h="8px"
                            borderRadius="36px"
                          /> */}
                        </SimpleGrid>
                        <Flex mb="15px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="1"
                              percentage={checkForm ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={checkForm ? textColorTertiary : "red.500"}
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Informações Cadastrais
                          </Text>
                          {checkForm && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                        {errosList.map((e) => (
                          <Flex
                            mb="5px"
                            ml="38px"
                            me="12px"
                            flexDirection="row"
                            alignItems="center"
                            fontSize="md"
                            color={textColorSecondary}
                            fontWeight="300"
                          >
                            <Icon
                              as={MdClear}
                              h="18px"
                              w="18px"
                              mr="5px"
                              color={"red.500"}
                            />{" "}
                            {e}
                          </Flex>
                        ))}
                        <Flex mt="10px" mb="25px" align="center">
                          <Box w="30px" me="12px">
                            <CircProgressMini
                              step="2"
                              percentage={IsNotEmpty(image) ? 100 : 0}
                            />
                          </Box>
                          <Text
                            color={
                              IsNotEmpty(image) ? textColorTertiary : window.config.tenant !== "Partiu" ? "red.500" : "orange.500"
                            }
                            fontWeight="500"
                            fontSize="md"
                            me="5px"
                          >
                            Biometria Facial
                          </Text>
                          {IsNotEmpty(image) && (
                            <Icon
                              as={MdCheck}
                              h="18px"
                              w="18px"
                              color={"green.500"}
                            />
                          )}
                        </Flex>
                      </Flex>
                      {(IsNotEmpty(historicoStatus) || checkForm) && (
                        <OrderStatus
                          ms={{ base: "0px", lg: "20px" }}
                          mt={{ base: "0px", lg: "0px" }}
                          zIndex="0"
                          p="0 20px"
                          gridArea={{
                            base: "2 / 1 / 3 / 3",
                            lg: "1 / 2 / 2 / 3",
                          }}
                          statusData={historicoStatus}
                          dataCadastro={dataCadastroUser}
                        />
                      )}
                    </Grid>
                    <Divider mb="20px" mt="25px" />
                    {IsNotEmpty(image) &&
                      (files.length === docsObrigatoriosList.length ||
                        filesReceived.length === docsObrigatoriosList.length) &&
                      checkForm &&
                      IsNotEmpty(operadora) ? (
                      <Flex justify="space-between" mt="24px">
                        <Button
                          variant="light"
                          fontSize="sm"
                          borderRadius="16px"
                          leftIcon={
                            <MdOutlineDoubleArrow
                              size="20px"
                              style={{ rotate: "180deg" }}
                            />
                          }
                          p="25px"
                          onClick={() => cartaoTab.current.click()}
                        >
                          Anterior
                        </Button>
                        {statusAtual < 2 && (
                          <Button
                            variant="solid"
                            colorScheme="green"
                            fontSize="sm"
                            borderRadius="16px"
                            p="25px"
                            onClick={() => nextFinallyFree()}
                            leftIcon={<MdOutlineEngineering size="20px" />}
                          >
                            Aprovar Gratuidade
                          </Button>
                        )}
                      </Flex>
                    ) : (
                      <Flex
                        direction="column"
                        w="100%"
                        color={textColorTertiary}
                      >
                        {/* <TextField
                          id="obs"
                          label="Observação "
                          h="100px"
                          w="100%"
                          maxLength="150"
                          placeholder="Explique porque será concedido mesmo com restrição de informações. Max 150 caracteres!"
                          value={obsRestricao}
                          onChange={(e: {
                            target: { value: React.SetStateAction<string> };
                          }) => setObsRestricao(e.target.value)}
                        /> */}
                        <Flex mt="24px" justify="space-between">
                          <Button
                            variant="light"
                            fontSize="sm"
                            borderRadius="16px"
                            p="25px"
                            leftIcon={
                              <MdOutlineDoubleArrow
                                size="20px"
                                style={{ rotate: "180deg" }}
                              />
                            }
                            onClick={() => mediaTab.current.click()}
                          >
                            Anterior
                          </Button>
                          {/* {checkForm && statusAtual < 2 && ( */}
                          <Button
                            variant="solid"
                            colorScheme="green"
                            fontSize="sm"
                            borderRadius="16px"
                            isLoading={loading}
                            loadingText="Aguarde..."
                            disabled={
                              window.config.tenant !== "Partiu" ? (loading ||
                                temGratuidade === true ||
                                stateAlterarBiometria === false) || !isAbleToGiveGratuidade()
                                ? true
                                : false
                                : !isAbleToGiveGratuidade()
                                  ? true
                                  : false}
                            onClick={() => nextFinallyFree()}
                            leftIcon={<MdOutlineEngineering size="20px" />}
                            p="25px"
                          >
                            Conceder gratuidade
                          </Button>
                          {/* )} */}
                        </Flex>
                      </Flex>
                    )}
                    <Divider mb="20px" mt="25px" />
                    <Flex direction="column" w="100%" color={textColorTertiary}>
                      {/* <HistoricoTickets
                        dataUser={dataUser[0]}
                        ticketUserNovo={ticketGerado}
                      /> */}
                      <TextField
                        id="observacaoChamado"
                        label="Observação do chamado"
                        h="100px"
                        w="100%"
                        maxLength="150"
                        placeholder="Digite detalhes sobre o atendimento do chamado. Max 150 caracteres"
                        value={observacaoChamado}
                        onChange={(e: {
                          target: { value: React.SetStateAction<string> };
                        }) => setObservacaoChamado(e.target.value)}
                      />
                      <Flex
                        direction="column"
                        w="100%"
                        color={textColorTertiary}
                        alignItems={"flex-end"}
                      >
                        {/* <Button
                            ml={"15px"}
                            w={"263px"}
                            colorScheme="brand"
                            mr={1}
                            onClick={encaminharAtendimento}
                            isLoading={loadingEncaminhar}
                            disabled={observacaoChamado === "" ? true : false}
                          >
                            Encaminhar atendimento
                          </Button> */}

                        <Button
                          ml={"240px"}
                          w={"263px"}
                          colorScheme="brand"
                          mr={1}
                          onClick={() => finalizarAtendimento()}
                          isLoading={loading}
                        //disabled={observacaoChamado === "" ? true : false}
                        >
                          Finalizar atendimento
                        </Button>
                      </Flex>
                    </Flex>
                  </Card>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </>
      )}
      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent
          alignSelf={"center"}
          bgColor={!IsEmpty(dataUser) ? "white" : "green.600"}
          w={"630px"}
        >
          <ModalHeader>
            {!IsEmpty(dataUser) ? (
              <Text fontSize="xl" color={"black"} fontWeight="bold">
                Deseja iniciar atendimento?
              </Text>
            ) : (
              <Text fontSize="xl" color={"white"} fontWeight="bold">
                Deseja iniciar o cadastro a este novo cliente?
              </Text>
            )}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {!IsEmpty(dataUser) ? (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"black"}>
                    <b>Cpf:</b> {maskCpfCnpj(cpfSearch)}
                  </Text>
                ) : null}

                <Text fontSize="xl" color={"black"}>
                  <b>Nome:</b> {nomeUsuario}
                </Text>
              </Flex>
            ) : (
              <Flex direction={"column"}>
                {cpfSearch ? (
                  <Text fontSize="xl" color={"white"}>
                    <b>Cpf:</b> {cpfSearch}
                  </Text>
                ) : null}
              </Flex>
            )}
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="brand"
              mr={3}
              onClick={() => confirmarAtendimento(null)}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      <Modal isOpen={modalData} onClose={onChangeModalDataClose} size={"sm"}>
        <ModalOverlay />
        <ModalContent alignSelf={"center"}>
          <ModalHeader>Escolha a data</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Flex justify="flex-start" h={"332px"} w={"623px"}>
              <DateRangePicker
                className="rdrDefinedRangesWrapper "
                onChange={handleSelect}
                moveRangeOnFirstSelection={false}
                months={1}
                showMonthAndYearPickers={false}
                ranges={[selectedDateRange]}
                displayMode="date"
                direction="horizontal"
                locale={pt}
                //singleDatePicker={true}
                dragSelectionEnabled={false}
                showDateDisplay={false}
                headerContent={false}
                scroll={{ enabled: false }}
                showPreview={false}
                dateDisplayFormat="dd MMM, yyyy"
                editableDateInputs={false}
                staticRanges={[]}
                inputRanges={[]}
              />
            </Flex>
          </ModalBody>
          <ModalFooter>
            <Button
              leftIcon={<MdSearch />}
              colorScheme="brand"
              mr={3}
              onClick={() => {
                setDataValidade(selectedDateRange.startDate);
                onChangeModalDataClose();
              }}
            >
              Confirmar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
